import React, { useEffect, useState } from "react";
import { Form, Button, Card, Row, Col, Modal, Badge } from "react-bootstrap";
import useAxiosPrivate from "../../../Pages/hooks/useAxiosPrivate";
import { baseURL, ACADIMAC } from "../../../API/API";
import { toast } from "react-toastify";
import Lodingsubmit from "../../Loding/Loding";

export default function LandingCardsDashboard() {
  const axiosPrivate = useAxiosPrivate();
  const [loading, setLoading] = useState(false);
  const [cards, setCards] = useState([]);
  const [academics, setAcademics] = useState([]);
  const [teachers, setTeachers] = useState([]);

  // Modal State
  const [showModal, setShowModal] = useState(false);
  const [editingCard, setEditingCard] = useState(null);
  const [selectedSlot, setSelectedSlot] = useState(1);
  const [selectedAcademicId, setSelectedAcademicId] = useState("");
  const [selectedTeacherId, setSelectedTeacherId] = useState("");
  const [subtitle, setSubtitle] = useState("");
  const [thumbnailFile, setThumbnailFile] = useState(null);
  const [isActive, setIsActive] = useState(true);

  // Fetch initial data
  const fetchData = async () => {
    setLoading(true);
    try {
      const [cardsRes, academicsRes, teachersRes] = await Promise.all([
        axiosPrivate.get(`${baseURL}/learning/landing-stage-cards`),
        axiosPrivate.get(`${baseURL}/${ACADIMAC}`),
        axiosPrivate.get(`${baseURL}/learning/teachers`, { params: { include_admin: 1 } }),
      ]);
      setCards(cardsRes.data?.data || []);
      setAcademics(academicsRes.data?.data || []);
      setTeachers(teachersRes.data?.data || []);
    } catch (err) {
      console.error(err);
      toast.error("فشل تحميل البيانات الأساسية للصفحة");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [axiosPrivate]);

  const handleEditClick = (card) => {
    setEditingCard(card);
    setSelectedSlot(card.slot || 1);
    setSelectedAcademicId(card.academic_year_id || "");
    setSelectedTeacherId(card.teacher_id || "admin");
    setSubtitle(card.academic_year?.subtitle || "");
    setThumbnailFile(null);
    setIsActive(card.is_active ?? true);
    setShowModal(true);
  };

  const handleModalClose = () => {
    setShowModal(false);
    setEditingCard(null);
  };

  const handleAcademicChange = (e) => {
    const id = e.target.value;
    setSelectedAcademicId(id);
    const academic = academics.find((ac) => String(ac.id) === String(id));
    setSubtitle(academic?.subtitle || "");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!editingCard) return;

    setLoading(true);
    const formData = new FormData();
    formData.append("slot", selectedSlot);
    formData.append("academic_year_id", selectedAcademicId || "-");
    formData.append("teacher_id", selectedTeacherId || "admin");
    formData.append("subtitle", subtitle);
    formData.append("is_active", isActive ? "1" : "0");
    if (thumbnailFile) {
      formData.append("thumbnail", thumbnailFile);
    }

    try {
      await axiosPrivate.post(`${baseURL}/learning/landing-stage-cards/update`, formData, {
        headers: { "Content-Type": "multipart/form-data" }
      });
      toast.success("تم تحديث الكارت بنجاح");
      setShowModal(false);
      fetchData(); // Refresh list
    } catch (err) {
      console.error(err);
      toast.error(err.response?.data?.message || "حدث خطأ أثناء التحديث");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {loading && <Lodingsubmit />}
      <div className="p-4 content" dir="rtl">
        <h2 className="fw-bold mb-3">عايز سنة كام ؟</h2>
        <p className="text-muted mb-5">
          تحكم في الكروت الـ 6 المعروضة في الصفحة الرئيسية للمنصة. يمكنك تحديد الصف الدراسي لكل كارت والمدرس المسؤول عنه ورفع ثامنيل مخصص له.
        </p>

        <Row className="g-4">
          {cards.map((card) => (
            <Col key={card.id} xs={12} md={6} lg={4}>
              <Card className="shadow-sm border-0 h-100" style={{ borderRadius: "12px", overflow: "hidden" }}>
                <div style={{ height: "180px", backgroundColor: "#f1f5f9", position: "relative" }}>
                  {card.thumbnail_path ? (
                    <img
                      src={card.thumbnail_path}
                      alt={`الكارت ${card.slot}`}
                      style={{ width: "100%", height: "100%", objectFit: "cover" }}
                    />
                  ) : (
                    <div className="d-flex align-items-center justify-content-center h-100 text-muted">
                      <span>لا توجد صورة مخصصة</span>
                    </div>
                  )}
                  <Badge
                    bg={card.is_active ? "success" : "secondary"}
                    style={{ position: "absolute", top: "12px", right: "12px", fontSize: "0.85rem" }}
                  >
                    {card.is_active ? "نشط" : "غير نشط"}
                  </Badge>
                  <div
                    style={{
                      position: "absolute",
                      bottom: "12px",
                      left: "12px",
                      backgroundColor: "rgba(0,0,0,0.6)",
                      color: "#fff",
                      padding: "4px 10px",
                      borderRadius: "6px",
                      fontSize: "0.85rem",
                      fontWeight: "bold",
                    }}
                  >
                    كارت رقم {card.slot}
                  </div>
                </div>
                <Card.Body className="d-flex flex-column text-end p-4">
                  <div className="mb-2">
                    <span className="text-muted small">الصف الدراسي:</span>
                    <h5 className="fw-bold mt-1" style={{ color: "#0f172a" }}>
                      {card.academic_year?.name || "غير محدد"}
                    </h5>
                  </div>
                  <div className="mb-4">
                    <span className="text-muted small">المدرس:</span>
                    <p className="fw-semibold mb-0" style={{ color: "#475569" }}>
                      {card.teacher?.name || "الأدمن (افتراضي)"}
                    </p>
                  </div>
                  <Button
                    variant="outline-primary"
                    className="w-100 mt-auto fw-bold"
                    style={{ borderRadius: "8px" }}
                    onClick={() => handleEditClick(card)}
                  >
                    تعديل الكارت
                  </Button>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </div>

      {/* Edit Modal */}
      <Modal show={showModal} onHide={handleModalClose} centered dir="rtl" className="text-end">
        <Modal.Header closeButton className="d-flex justify-content-between align-items-center">
          <Modal.Title className="fw-bold">تعديل الكارت</Modal.Title>
        </Modal.Header>
        <Form onSubmit={handleSubmit}>
          <Modal.Body className="p-4">
            <Form.Group className="mb-4">
              <Form.Label className="fw-bold">رقم الكارت (الترتيب في الصفحة الرئيسية)</Form.Label>
              <Form.Select
                value={selectedSlot}
                onChange={(e) => setSelectedSlot(parseInt(e.target.value))}
                style={{ direction: "rtl" }}
              >
                <option value="1">كارت رقم 1</option>
                <option value="2">كارت رقم 2</option>
                <option value="3">كارت رقم 3</option>
                <option value="4">كارت رقم 4</option>
                <option value="5">كارت رقم 5</option>
                <option value="6">كارت رقم 6</option>
              </Form.Select>
            </Form.Group>

            <Form.Group className="mb-4">
              <Form.Label className="fw-bold">الصف الدراسي</Form.Label>
              <Form.Select
                value={selectedAcademicId}
                onChange={handleAcademicChange}
                style={{ direction: "rtl" }}
              >
                <option value="">-- اختر الصف الدراسي --</option>
                {academics.map((ac) => (
                  <option key={ac.id} value={ac.id}>
                    {ac.name}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>

            <Form.Group className="mb-4">
              <Form.Label className="fw-bold">الكلمة التوضيحية الذهبية (مثل: ثانوي عام أو أزهري)</Form.Label>
              <Form.Control
                type="text"
                placeholder="اتركه فارغاً للاعتماد على نوع القسم، أو اكتب كلمة مخصصة"
                value={subtitle}
                onChange={(e) => setSubtitle(e.target.value)}
                style={{ direction: "rtl" }}
              />
            </Form.Group>

            <Form.Group className="mb-4">
              <Form.Label className="fw-bold">اسم المدرس</Form.Label>
              <Form.Select
                value={selectedTeacherId}
                onChange={(e) => setSelectedTeacherId(e.target.value)}
                style={{ direction: "rtl" }}
              >
                <option value="admin">الأدمن (افتراضي)</option>
                {teachers
                  .filter((t) => t.id !== "admin")
                  .map((t) => (
                    <option key={t.id} value={t.id}>
                      {t.name} ({t.subject || "غير محدد"})
                    </option>
                  ))}
              </Form.Select>
            </Form.Group>

            <Form.Group className="mb-4">
              <Form.Label className="fw-bold">ثامنيل المدرس (صورة الكارت)</Form.Label>
              <Form.Control
                type="file"
                accept="image/*"
                onChange={(e) => setThumbnailFile(e.target.files[0])}
              />
              <Form.Text className="text-muted">
                اتركه فارغاً للحفاظ على الصورة الحالية أو استخدام الصورة الافتراضية للكارت.
              </Form.Text>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Check
                type="checkbox"
                label="كارت نشط (يظهر في الصفحة الرئيسية)"
                checked={isActive}
                onChange={(e) => setIsActive(e.target.checked)}
                className="fs-6"
              />
            </Form.Group>
          </Modal.Body>
          <Modal.Footer className="justify-content-start gap-2">
            <Button variant="secondary" onClick={handleModalClose}>
              إلغاء
            </Button>
            <Button variant="primary" type="submit">
              حفظ التغييرات
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </>
  );
}
